<template>
    <div class="page page-home footer_show" :class="{'header_show':$util.myBrowser() != 'micromessenger'}">
        <page-header v-if="$util.myBrowser() != 'micromessenger'" :pageinfo="pageInfo"></page-header>
            <div class="page-content">
                <div class="page-topbar" style="background-color:#fff;height:65px;border-bottom:1px solid #ccc;">
                  <div class="f-textItem" style="display:inline-block;margin-left:10px;margin-top:5px;color:#6e6a6a">
                       <p class="f-amountTitle" style="font-size: 14px;">
                                   {{userInfo.merchantName}}
                                </p>
                                <p class="f-amountTitle" style="font-size: 14px;margin-bottom:5px;margin-top:5px;">
                                    {{userInfo.merchantNo}}
                                </p>
                  </div>
                  <div style="background-color:#f5f5f5;height:35px;display:inline-block;">
                    <div @click="tapCanlendar" style="height:45px;line-height:45px;position:absolute;right:10px;">
                        <label style="margin-right:5px;font-size:15px;">{{currentSelectedDateShow}}</label>
                        <Icon type="calendar" style="font-size:20px;"></Icon>
                    </div>
                    <calendar v-model="calendarShow" :defaultDate="defaultDate" @change="handelChange" format="yyyy/MM/dd"></calendar>
                </div>
              </div>
              <on-scroll :on-refresh="onRefresh" :on-infinite="onInfinite" :dataList="scrollData"> 
                <ul class="m-cells m-cells-total" style="background-color:#26a2ff;width:100%;"> 
                    <li class="m-cell-total-tab">
                       <div>
                           <div class="m-cell-total-tab-unit m-cell-total-tab-unit-left">
                               <p class="m-cell-total-tab-unit-title">QUANTITY</p>
                               <p class="m-cell-total-tab-unit-title">SALES</p>
                               <p class="m-cell-total-tab-unit-title">TIPS</p>
                               <p class="m-cell-total-tab-unit-title">TAX</p>
                               <p class="m-cell-total-tab-unit-title" v-if="totalMap.customTaxAmount">CUSTOM TAX</p>
                               <p class="m-cell-total-tab-unit-title">CONVENIENCE FEE</p>
                               <p class="m-cell-total-tab-unit-title" v-if="totalMap.otherFeeAmount">OTHER FEE</p>
                               <p class="m-cell-total-tab-unit-title">SVC</p>
                               <p class="m-cell-total-tab-unit-title">REFUND</p>
                               <p class="m-cell-total-tab-unit-title">VOID</p>
                               <p class="m-cell-total-tab-unit-title">NET SALES</p>                
                           </div>
                           <div class="m-cell-total-tab-unit m-cell-total-tab-unit-right">
                              <!-- <p class="m-cell-total-tab-unit-content"><span> {{countMap.netSalesCounts+countMap.salesCounts+countMap.refundCounts | ifnulltozero}} </span></p> -->
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.netSalesCounts | ifnulltozero}} </span></p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.salesAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.tipAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.taxAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content" v-if="totalMap.customTaxAmount"><span> {{totalMap.customTaxAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.convenientFeeAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content" v-if="totalMap.otherFeeAmount"><span> {{totalMap.otherFeeAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.svc | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content">
                                <span style="color:#fff;"> <span v-if="totalMap.refundAmount >0" style="margin-right:-5px;">-</span>
                                    {{totalMap.refundAmount|ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.voidAmount | ifnulltozero}} </span>{{currency}}</p>
                              <p class="m-cell-total-tab-unit-content"><span> {{totalMap.netSalesAmount | ifnulltozero}} </span>{{currency}}</p>
                           </div>
                       </div>
                    </li>
                  </ul>
                <ul class="f-datalist m-cells" style="background-color:#f5f5f5">  
                    <AmountSummary
                        :titles="['Sales','Qty','Amount']"   
                        :counts="sales.counts"
                        :values="sales.amounts"
                        :columnNames="sales['columnNames']"
                        :currency="currency"
                    ></AmountSummary>
                    <AmountSummary
                        :titles="['Tip','Qty','Amount']"
                        :counts="tip.counts"
                        :values="tip.amounts"
                        :columnNames="tip['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <AmountSummary
                        :titles="['Tax','Qty','Amount']" 
                        :counts="tax.counts"
                        :values="tax.amounts"
                        :columnNames="tax['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <AmountSummary
                        :titles="['Convenience Fee','Qty','Amount']" 
                        :counts="convenientFee.counts"
                        :values="convenientFee.amounts"
                        :columnNames="convenientFee['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <!-- <AmountSummary
                        :titles="['SVC','Qty','Amount']" 
                        :counts="svc.counts"
                        :values="svc.amounts"
                        :columnNames="svc['columnNames']" 
                        :currency="currency"
                    ></AmountSummary> -->
                    <AmountSummary 
                        v-if="showOtherFeeAmount"
                        :titles="['Other Fee','Qty','Amount']" 
                        :counts="otherFeeAmount.counts"
                        :values="otherFeeAmount.amounts"
                        :columnNames="otherFeeAmount['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                      <!-- :counts="[otherFeeAmount.alipayCounts,otherFeeAmount.wechatpayCounts,otherFeeAmount.creditcardCounts,otherFeeAmount.paypalCounts,otherFeeAmount.debitcardCounts,otherFeeAmount.unionpayCounts,otherFeeAmount.venmoCounts]" -->
                        <!-- :values="[otherFeeAmount.alipayAmount,otherFeeAmount.wechatpayAmount,otherFeeAmount.creditcardAmount,otherFeeAmount.paypalAmount,otherFeeAmount.debitcardAmount,otherFeeAmount.unionpayAmount,otherFeeAmount.venmoAmount]" -->
                        
                    <AmountSummary 
                        v-if="showCustomTax"
                        :titles="['Custom Tax','Qty','Amount']" 
                        :counts="customTax.counts"
                        :values="customTax.amounts"
                        :columnNames="customTax['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <AmountSummary
                        :titles="['Refund','Qty','Amount']" 
                        :counts="refund.counts"
                        :values="refund.amounts"
                        :columnNames="refund['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <AmountSummary
                        :titles="['Void','Qty','Amount']" 
                        :counts="voids.counts"
                        :values="voids.amounts"
                        :columnNames="voids['columnNames']" 
                        :currency="currency"
                    ></AmountSummary>
                    <!-- <AmountSummary
                        :titles="['Net Sales','Qty','Amount']"
                        :counts="[netSales.alipayCounts,netSales.wechatpayCounts,netSales.creditcardCounts,netSales.paypalCounts,netSales.debitcardCounts,netSales.unionpayCounts,netSales.venmoCounts]"
                        :values="[netSales.alipayAmount,netSales.wechatpayAmount,netSales.creditcardAmount,netSales.paypalAmount,netSales.debitcardAmount,netSales.unionpayAmount,netSales.venmoAmount]"
                        :currency="currency"
                    ></AmountSummary> -->
                </ul>
                </on-scroll>
            </div> 
         
        <page-footer></page-footer>
    </div>
</template>

<script>
import AmountSummary from './main_components/amountSummary'
export default {
    name: 'home',
    components:{
        'AmountSummary':AmountSummary
    },
    data() {
        return {
            pageInfo:{
                title:"首页",
            },
            scrollData: {
                noFlag: false //暂无更多数据显示
            },
            current: 1,
            size: 10,
            perpage: 10,
            totalSize: 0,
            startDate:this.$util.formatDate(new Date(),'',),
            endDate:this.$util.formatDate(new Date(),'',),
            countmap:{},
            tablelist:[],
            value1: this.$util.formatDate(new Date(),'',),
            calendarShow:false,
            defaultDate:new Date(),
            currentSelectedDate:this.$util.formatDate(new Date(),'',),
            currentSelectedDateShow:this.$util.formatDate(new Date(),'',).replace(/-/g,"/"),
            sales:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            refund:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            netSales:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            countMap:{},
            totalMap:{ },
            currency:"",
            tip:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            tax:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            convenientFee:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            voids:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            svc:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            otherFeeAmount:{
                columnNames:[],
                counts:[],
                amounts:[]
            },
            customTax: {
                columnNames:[],
                counts:[],
                amounts:[]
            },
            sumAmount:{},
            channel:['total','alipay','wechatpay','creditcard','paypal','debitcard','unionpay','venmo'],
            columnNames:{
                alipay:'Alipay',wechatpay:'WeChat Pay',creditcard:'Credit Card',paypal:'Paypal',debitcard:'Debit Card',unionpay:'Unionpay',venmo:'Venmo'
            } ,
            showOtherFeeAmount:false,
            showCustomTax:false
        };
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo?this.$store.state.userInfo:{};
        }
    },
    methods: {
        init() {
            this.$store.commit("getuserinfo",{refresh:true});
            //this.$ajax.getOpenid(this);
            this.$util.title(this.pageInfo.title);
        },
        setPaymentChannel(data,type){
            //console.log(data,type)
            if(data!=undefined){
                data = data.toLowerCase();
                type = type.toLowerCase();
            }
            return data.indexOf(type)>=0
        },
        handelChange(date,formatDate){
            this.currentSelectedDate=this.$util.formatDate(date,'',);
            this.currentSelectedDateShow=this.currentSelectedDate.replace(/-/g,"/");
            this.getlist();
        },
        tapCanlendar(){
           this.calendarShow=this.calendarShow==true?false:true;
        },
        onRefresh(done) {
            this.perpage = this.perpage * this.current;
            this.current = 1;
            this.tablelist = [];
            this.getlist(()=>{
                done()
            });
        },
        onInfinite(done) {
            console.log('onInfinite');
            this.current=1;
            //走完数据调用方法
            this.getlist(()=>{
                this.scrollData.noFlag = true;
                done()
            });
        },
        modifyResult(obj){
            for(let k in obj){
                if(!obj[k]){
                    obj[k] = 0
                }
            }
            return obj
        },
        getlist(done) {
            this.$Indicator.open('loading...');
            console.log('getlist');
            this.ajaxPromiseAll(done);
            return
            console.log(this.currentSelectedDate);
            console.log(this.$util.formatDate(this.currentSelectedDate, '',8)+" 00:00:00");
            console.log(this.$util.formatDate(this.currentSelectedDate, '',8)+" 23:59:59");
            var d=new Date();
            console.log(-d.getTimezoneOffset()/60);
            //console.log('home=>getlist=>this.$ajax.ajaxUrlPart: ',this.$ajax.ajaxUrlPart);
            this.$ajax.post(this.$ajax.ajaxUrlPart + '/wxoauser/summary', {
            // this.$ajax.post(this.$ajax.ajaxUrlPart + '/app-pos-report/summary/v2', {
                startDate: this.$util.formatDate(this.currentSelectedDate, '',8)+" 00:00:00",
                endDate: this.$util.formatDate(this.currentSelectedDate, '',8)+" 23:59:59",
                //page: this.current,//this.current == undefined ? 1 : this.current,
                //size: this.perpage,//parseInt(this.current) * parseInt(this.perpage),
                transactionStatus:'100',
                page: 1,
                size: 1000,
                timezone:-d.getTimezoneOffset()/60,    
            }).then((result) => {
                    done==undefined?'':done();
                    //console.log('done',done);
                this.$ajax.handleAjaxResult(this,result);
                if(result&&result.ret_code=='000100'){
                    console.log('获取数据成功');
                    console.log(result);
                    if(result.countMap){
                        this.countMap=result.countMap;
                    }else{
                        this.countMap={
                            "refundCounts": 0,
                            "salesAmount": 0,
                            "netSalesCounts": 0,
                            "tip": 0,
                            "svc":0,
                            "salesCounts": 0,
                            "netSalesAmount": 0,
                            "refundAmount": 0,
                            "tax":0,
                            'customTax':0,
                            'otherFeeAmount':0,
                            "convenientFee": 0,
                            "voidsAmount": 0,
                            "voidsCounts": 0,
                        }
                    }
                    if(result.sales){
                        this.sales=result.sales;
                        this.sales = this.modifyResult(this.sales);
                    }else{
                        this.sales={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.refund){
                        this.refund=result.refund;
                        this.refund = this.modifyResult(this.refund);
                    }else{
                        this.refund={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.netSales){
                        this.netSales=result.netSales;
                        this.netSales = this.modifyResult(this.netSales);
                    }else{
                        this.netSales={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.tip){
                        this.tip=result.tip;
                        this.tip = this.modifyResult(this.tip);
                    }else{
                        this.tip={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.tax){
                        this.tax=result.tax;
                        this.tax = this.modifyResult(this.tax);
                    }else{
                        this.tax={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.convenientFee){
                        this.convenientFee=result.convenientFee;
                        this.convenientFee = this.modifyResult(this.convenientFee);
                    }else{
                        this.convenientFee={
                            "wechatCounts": 0,
                            "alipayCounts": 0,
                            "wechatAmount": 0,
                            "creditCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0
                        }
                    }
                    if(result.void){
                        this.voids=result.void;
                        this.voids = this.modifyResult(this.voids);
                    }else{
                        this.voids={
                            "creditCounts": 0,
                            "wechatAmount": 0,
                            "alipayCounts": 0,
                            "alipayAmount": 0,
                            "creditAmount": 0,
                            "wechatCounts": 0
                        }
                    }
                    if(result.svc){
                        this.svc = result.svc
                        this.svc = this.modifyResult(this.svc)
                    }else {
                        this.svc = {
                            alipayAmount: 0,
                            alipayCounts: 0,
                            creditAmount: 0,
                            creditCounts: 0,
                            wechatAmount: 0,
                            wechatCounts: 0,
                        }
                    }
                    if(result.customTax){
                        this.customTax = result.customTax
                        this.customTax = this.modifyResult(this.customTax)
                    }else {
                        this.customTax = {}
                    }
                    if(result.otherFeeAmount){
                        this.otherFeeAmount = result.otherFeeAmount
                        this.otherFeeAmount = this.modifyResult(this.otherFeeAmount)
                    }else {
                        this.otherFeeAmount = {}
                    }
                    this.currency=result.currency;
                }


            }).catch(err => {
                //console.log('home=>getlist=>err: ',err);
                //console.log('home=>getlist=>err.status: ',err.status);
                this.$ajax.handleAjaxError(this, err);
            })
        },
        processData(data){
            console.log('processData',data)
            if(data.length>0){  
                let _data = {
                    columnNames:[],
                    counts:[],
                    amounts:[]
                }
                this.sales =JSON.parse(JSON.stringify(_data));
                this.tip =JSON.parse(JSON.stringify(_data));
                this.tax = JSON.parse(JSON.stringify(_data));
                this.convenientFee = JSON.parse(JSON.stringify(_data));
                this.svc =JSON.parse(JSON.stringify(_data));
                this.refund = JSON.parse(JSON.stringify(_data));
                this.voids = JSON.parse(JSON.stringify(_data));
                this.netSales = JSON.parse(JSON.stringify(_data));
                this.otherFeeAmount=JSON.parse(JSON.stringify(_data));
                this.customTax =JSON.parse(JSON.stringify(_data));
                this.totalMap={
                    "refundCounts": 0,
                    "salesAmount": 0,
                    "netSalesCounts": 0,
                    "tip": 0,
                    "svc":0,
                    "salesCounts": 0,
                    "netSalesAmount": 0,
                    "refundAmount": 0,
                    "tax":0,
                    'customTax':0,
                    'otherFeeAmount':0,
                    "convenientFee": 0,
                    "voidsAmount": 0,
                    "voidsCounts": 0,
                }  
                console.log('Promise',data)  
               

                data.forEach(el=>{ 
                    let _channel = el.searchChannel
                    this.currency= el.currency;
                    if(_channel){   
                        if(el.countMap['salesAmount'] || el.countMap['salesAmount'] ===0){
                            this.sales.columnNames.push(this.columnNames[_channel]) 
                            this.sales.amounts.push(el.countMap['salesAmount'])
                            this.sales.counts.push(el.countMap['salesCounts'])
                        } 

                        if(el.countMap['tipAmount'] || el.countMap['tipAmount'] ===0){
                            this.tip.columnNames.push(this.columnNames[_channel]) 
                            this.tip.amounts.push(el.countMap['tipAmount'])
                            this.tip.counts.push(el.countMap['tipCount'])
                        }  

                        if(el.countMap['taxAmount'] || el.countMap['taxAmount'] ===0){
                            this.tax.columnNames.push(this.columnNames[_channel]) 
                            this.tax.amounts.push(el.countMap['taxAmount'])
                            this.tax.counts.push(el.countMap['taxCount'])
                        }

                        if(el.countMap['convenientFeeAmount'] || el.countMap['convenientFeeAmount'] ===0){
                            this.convenientFee.columnNames.push(this.columnNames[_channel]) 
                            this.convenientFee.amounts.push(el.countMap['convenientFeeAmount'])
                            this.convenientFee.counts.push(el.countMap['convenientFeeCount'])
                        }

                        // if(el.countMap['svc'] || el.countMap['svc'] ===0){
                        //     this.svc.columnNames.push(this.columnNames[_channel]) 
                        //     this.svc.amounts.push(el.countMap['svc'])
                        //     this.svc.counts.push(el.countMap['svcCount'])
                        // }

                        if(el.countMap['otherFeeAmount']|| el.countMap['otherFeeAmount'] ===0){
                            if(el.countMap['otherFeeAmount']){
                                this.showOtherFeeAmount = true 
                            }
                            this.otherFeeAmount.columnNames.push(this.columnNames[_channel]) 
                            this.otherFeeAmount.amounts.push(el.countMap['otherFeeAmount'])
                            this.otherFeeAmount.counts.push(el.countMap['otherFeeCount'])
                        }
                        
                        if(el.countMap['customTaxAmount']|| el.countMap['customTaxAmount'] ===0){
                            if(el.countMap['customTaxAmount']){
                                this.showCustomTax = true
                            }
                            this.customTax.columnNames.push(this.columnNames[_channel]) 
                            this.customTax.amounts.push(el.countMap['customTaxAmount'])
                            this.customTax.counts.push(el.countMap['customTaxCount'])
                        }

                        if(el.countMap['refundAmount'] || el.countMap['refundAmount'] ===0){
                            this.refund.columnNames.push(this.columnNames[_channel]) 
                            this.refund.amounts.push(el.countMap['refundAmount'])
                            this.refund.counts.push(el.countMap['refundCounts'])
                        } 

                        if(el.countMap['voidAmount'] || el.countMap['voidAmount'] ===0){
                            this.voids.columnNames.push(this.columnNames[_channel]) 
                            this.voids.amounts.push(el.countMap['voidAmount'])
                            this.voids.counts.push(el.countMap['voidCount'])
                        } 

                        if(el.countMap['netSalesAmount'] || el.countMap['netSalesAmount'] ===0){
                            this.netSales.columnNames.push(this.columnNames[_channel]) 
                            this.netSales.amounts.push(el.countMap['netSalesAmount'])
                            this.netSales.counts.push(el.countMap['netSalesCounts'])
                        }  
                    }else{
                        this.totalMap = el.countMap ? el.countMap: this.totalMap
                    } 
                }) 
            }
            
        },
        getChannelSum(data){
            var d=new Date();
            console.log(this.$ajax.ajaxUrlPart)
            return this.$ajax.post(this.$ajax.ajaxUrlPart + '/wxoauser/summary', { 
                startDate: this.$util.formatDate(this.currentSelectedDate, '',8)+" 00:00:00",
                endDate: this.$util.formatDate(this.currentSelectedDate, '',8)+" 23:59:59", 
                transactionStatus:'100',
                page: 1,
                size: 1000,
                timezone:-d.getTimezoneOffset()/60,    
                searchChannel: data.searchChannel||'' ,//渠道类型
            })
        },
        //一个接口所有数据会经常超时，所以拆分成8个请求（一个汇总请求，7个渠道请求）
        ajaxPromiseAll(done){ 
            let channelList = this.channel.map(el=>{
                return this.getChannelSum({searchChannel:el=='total'?'':el})
            }) 
            Promise.all(channelList).then((result) => { 
                done==undefined?'':done();
                this.$ajax.handleAjaxResult(this,result);
                this.processData(result)
            }).catch(err => {
                //console.log('home=>getlist=>err: ',err);
                //console.log('home=>getlist=>err.status: ',err.status);
                this.$ajax.handleAjaxError(this, err);
            })
        }
    },
    watch: {

    },
    mounted() {  
        this.getlist();
        this.init();
    },
}
</script>
<style scoped>
.yo-scroll{
   background-color:#f5f5f5;
   margin-top:115px;
}
.nullData{display:none!important;border:1px solid red;}
</style>



// WEBPACK FOOTER //
// src/views/home.vue